import request from '@/config/axios'

export interface FeedVO {
  id: number
  userId: number
  userNickname?: string
  userAvatar?: string
  content: string
  images?: string[]
  videoUrl?: string
  topicTags?: string
  locationName?: string
  feedType: number
  auditStatus: number
  auditRemark?: string
  status: number
  likeCount: number
  commentCount: number
  shareCount: number
  viewCount: number
  createTime: string
}

export const getFeedPage = (params: PageParam & Record<string, any>) =>
  request.get({ url: '/bosscircle/feed/page', params })
export const getAuditCounts = () =>
  request.get<Record<number, number>>({ url: '/bosscircle/feed/audit-counts' })
export const auditFeed = (id: number, auditStatus: number, auditRemark?: string) =>
  request.put({ url: `/bosscircle/feed/audit/${id}`, data: { auditStatus, auditRemark } })
export const batchAuditFeed = (ids: number[], auditStatus: number, auditRemark?: string) =>
  request.put({ url: '/bosscircle/feed/batch-audit', data: { ids, auditStatus, auditRemark } })
export const deleteFeed = (id: number) =>
  request.delete({ url: `/bosscircle/feed/delete/${id}` })
export const deleteFeedList = (ids: number[]) =>
  request.delete({ url: '/bosscircle/feed/delete-list', params: { ids: ids.join(',') } })
